import { Phone } from "lucide-react";
import { PHONE, PHONE_LINK } from "../data/menu";

const links = [
  { href: "#speisekarte", label: "Speisekarte", id: "nav-menu-link" },
  { href: "#oeffnungszeiten", label: "Öffnungszeiten", id: "nav-hours-link" },
  { href: "#bewertungen", label: "Bewertungen", id: "nav-reviews-link" },
  { href: "#kontakt", label: "Kontakt", id: "nav-contact-link" },
];

export const Navbar = () => (
  <header className="fixed top-0 left-0 right-0 z-40">
    <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 md:px-10">
      <a href="#top" data-testid="nav-logo-link" className="flex items-center gap-3">
        <img src="/assets/logo.jpg" alt="Imbiss Tsolias Logo" className="h-14 w-auto rounded-lg border border-[#E2E0D8] bg-white p-1 shadow-sm" />
        <span className="font-display text-2xl tracking-tight text-[#1A1C19]">Tsolias</span>
      </a>
      <nav className="hidden items-center gap-8 md:flex">
        {links.map((l) => (
          <a
            key={l.href}
            href={l.href}
            data-testid={l.id}
            className="text-xs font-semibold uppercase tracking-[0.18em] text-[#4A4D46] transition-colors duration-300 hover:text-[#4B7F94]"
          >
            {l.label}
          </a>
        ))}
      </nav>
      <a
        href={PHONE_LINK}
        data-testid="nav-call-button"
        className="flex items-center gap-2 rounded-full bg-[#1A1C19] px-5 py-2.5 text-xs font-semibold tracking-wide text-[#F9F8F6] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#4B7F94]"
      >
        <Phone size={14} strokeWidth={1.5} />
        <span className="hidden sm:inline">{PHONE}</span>
        <span className="sm:hidden">Anrufen</span>
      </a>
    </div>
  </header>
);
